import { isString } from 'lodash-es'

import { i18n } from 'locales'
import { shouldCreatePaymentSelector } from 'selectors/payment'

export const createPayment = (api) => (_dispatch, getState) => {
  if (shouldCreatePaymentSelector(getState())) {
    return api.createPayment()
  }
  return Promise.resolve(true)
}

export const setPaymentData = (data) => ({
  type: 'SCHEDULING_PAYMENT_DONE',
  payload: data
})

export const setPaymentError = (message) => ({
  type: 'SCHEDULING_PAYMENT_ERROR',
  payload: {
    message
  }
})

// i18n-tasks-use t("errors.booking.card.#{stripeError}")
export const setStripePaymentError = (stripeError) => {
  const message = i18n.t(
    `errors.booking.card.${stripeError.code}`,
    {
      defaults: [{ message: stripeError.message }]
    }
  )
  if (isString(message)) { return setPaymentError(message) }
  return setPaymentError(stripeError.message)
}

export const resetPayment = () => ({
  type: 'SCHEDULING_PAYMENT_RESET'
})

export const stripeClientSecretPending = () => ({
  type: 'SET_STRIPE_CLIENT_SECRET',
  payload: { status: 'loading', value: null }
})

export const stripeClientSecretFetched = (value, stripeAccount = null) => ({
  type: 'SET_STRIPE_CLIENT_SECRET',
  payload: { status: 'loaded', value, stripeAccount }
})

export const stripeClientSecretError = () => ({
  type: 'SET_STRIPE_CLIENT_SECRET',
  payload: { status: 'error', value: null, stripeAccount: null }
})

export const setStripePaymentElementReadyForCapture = () => ({
  type: 'SET_STRIPE_PAYMENT_ELEMENT_READY_FOR_CAPTURE'
})

export const setSaveFormDataForStripeRedirect = (value) => ({
  type: 'SET_SAVE_FORM_DATA_FOR_STRIPE_REDIRECT',
  payload: value
})
